import { Box, Typography, useTheme } from "@mui/material";
import bannerImage from "../../../../../media/images/courseCover.png";
import NotifsIcon from "../../../../../media/images/icons/notification-bing";
import NotifSVG2 from "../../../../../media/images/icons/notification-bing2";
import NotifCard from "../NotifCard";
import { useState } from "react";
export default function MessagesAndNotifs() {
  const theme = useTheme();

  const [notifs, setNotifs] = useState<
    {
      title: string;
      active: boolean;
      description: string;
      notifKey: string;
    }[]
  >([
    {
      title: "اطلاع از بار جدید با مشخصات ناوگان من",
      description:
        "با روشن کردن این اعلان، تا زمانی که به اینترنت متصل‌باشید، یک اعلان اطلاع‌رسانی از هر باری که با گروه بارگیر یا ناوگان شما قابل‌حمل باشد برای شما ارسال می‌شود.",
      active: true,
      notifKey: "notif1",
    },
    {
      title: "اطلاع از بار جدید با مشخصات ناوگان من",
      description:
        "با روشن کردن این اعلان، تا زمانی که به اینترنت متصل‌باشید، یک اعلان اطلاع‌رسانی از هر باری که با گروه بارگیر یا ناوگان شما قابل‌حمل باشد برای شما ارسال می‌شود.",
      active: false,
      notifKey: "notif2",
    },
    {
      title: "اطلاع از بار جدید با مشخصات ناوگان من",
      description:
        "با روشن کردن این اعلان، تا زمانی که به اینترنت متصل‌باشید، یک اعلان اطلاع‌رسانی از هر باری که با گروه بارگیر یا ناوگان شما قابل‌حمل باشد برای شما ارسال می‌شود.",
      active: false,
      notifKey: "notif3",
    },
  ]);

  const handleNotifs = (key: string, status: boolean) => {

    const newNotifs = notifs.map((item) => {

      if(item.notifKey === key) return {...item , active:!status}
      else
      return item
    })    

    setNotifs(newNotifs);
  };

  return (
    <Box
      sx={{
        display: "flex",
        marginTop: "16px",

        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          borderRadius: "16px",
          width: "100%",
          backgroundColor: "background.default",
          padding: "4px",
        }}
      >
        <img
          style={{
            borderRadius: "28px",
          }}
          width={"100%"}
          src={bannerImage}
          alt=""
        />
        <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          در این قسمت می‌توانید از طریق دکمه کنار هر اعلان، وضعیت اطلاع‌رسانی آن
          را روشن/خاموش کنید تا در زمان اتصال به اینترنت برای شما اعلان
          ارسال‌شود.
        </Typography>
      </Box>

      {notifs.map((item) => {
        return (
          <NotifCard
            notifKey={item.notifKey}
            active={item.active}
            description={item.description}
            title={item.title}
            handleSwitch={(key, status) => handleNotifs(key, status)}
          />
        );
      })}
    </Box>
  );
}
